<template>
  <portal to="body">
    <div v-if="isOpen" class="dialog-overlay">
      <div
        :id="id"
        tabindex="-1" 
        role="dialog" 
        class="ui-dialog"
        :aria-describedby="'dialog-content-' + uuid"
        :aria-labelledby="'dialog-title-' + uuid">
        <div class="ui-dialog-titlebar ui-widget-header ui-helper-clearfix">
          <span :id="'dialog-title-' + uuid" class="ui-dialog-title">{{ title }}</span>
          <button type="button" class="ui-button ui-button-icon-only ui-dialog-titlebar-close" @click="onClickClose()">
            <span class="ui-button-icon ui-icon ui-icon-closethick"></span>
            <span class="ui-button-icon-space"></span>
            Close
          </button>
        </div>
        <div :id="'dialog-content-' + uuid" class="ui-dialog-content ui-widget-content">
          <slot></slot>
        </div>
        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
          <div class="ui-dialog-buttonset">
            <slot name="buttons"></slot>
          </div>
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
let uuid = 0;

export default {
  name: "DialogComponent",
  props: {
    id: String,
    open: Boolean,
    title: String,
  },
  data() {
    return {
      uuid: 0,
      isOpen: false,
    };
  },
  created() {
    uuid++;
    this.uuid = uuid;
    this.isOpen = this.open;
  },
  watch: {
    open() {
      this.isOpen = this.open;
    }
  },
  methods: {
    onClickClose() {
      this.isOpen = false;
      this.$emit("update:open", false);
      this.$emit("close");
    }
  }
}
</script>

<style lang="less">
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(39, 39, 39, .2);

  .ui-dialog {
    min-width: 200px;
    min-height: 100px;
    max-width: calc(100% - 20px);
    max-height: calc(100% - 20px);
    position: relative;
  }
}
</style>
